import numeral from 'numeral';

import { UxGoodsCardItemForVerticalProductCard } from '@common/product-card';

import { GetPdpInfiniteRecommendItemList_pdp_infinite_recommend_group_item_list as PdpGoodsCardItem } from '../graphql/inifinite_recommend_types.2';

export function convertUxGoodsCardItemFromPdpGoodsCardItem(
  item: PdpGoodsCardItem,
): UxGoodsCardItemForVerticalProductCard {
  return {
    ...item,
    review_score: item.review_score && item.review_score >= 3 ? item.review_score : null,
    display_review_count:
      item.review_count && numeral(item.review_count).value() >= 3 ? String(item.review_count) : null,
    managed_category_list: null,
  };
}

export const convertPdpGoodsCardItemListToCatalogProductIdList = (data: UxGoodsCardItemForVerticalProductCard[]) => {
  return data.reduce((acc, item) => {
    const { catalog_product_id } = item;
    catalog_product_id && acc.push(catalog_product_id);
    return acc;
  }, [] as string[]);
};
